export default [
  {
    path: '/admin/business-units',
    name: 'business-unit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/business-unit/index.vue')
  }
]